// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__IBtnz","content":"LoadingAlert_content__Z2a1N"};